// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 16px;
  max-width: 1400px;
  margin: 0 auto;
  direction: rtl;
  text-align: right;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.summary-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.summary-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.25);
  color: white;
  transition: all 0.3s ease;
}
.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.35);
}
.summary-card.today-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.summary-card.month-card {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}
.summary-card .card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.summary-card .card-header ion-icon {
  font-size: 32px;
  color: white;
}
.summary-card .card-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.summary-card .summary-stats-inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.summary-card .stat-inline {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 120px;
}
.summary-card .stat-inline .stat-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.summary-card .stat-inline .stat-value {
  font-weight: 700;
  font-size: 28px;
  color: white;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.summary-card .stat-inline .stat-value.highlight {
  color: #FFD700;
  animation: pulse 2s ease-in-out infinite;
}
.summary-card .stat-inline .stat-value.highlight-success {
  color: #90EE90;
  animation: pulse 2s ease-in-out infinite;
}
.summary-card .stat-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  align-self: center;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
.tabs-container {
  margin-bottom: 24px;
}

.tab-content {
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.status-boxes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.status-box {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 5px solid;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.status-box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, transparent 0%, rgba(0, 0, 0, 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.status-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.status-box:hover::before {
  opacity: 1;
}
.status-box .status-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.status-box .status-count {
  font-size: 36px;
  font-weight: 800;
  color: #333;
  line-height: 1;
}

.filters-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.search-group {
  margin-bottom: 20px;
}
.search-group ion-searchbar {
  --background: #f5f7fa;
  --border-radius: 12px;
  --box-shadow: none;
  --placeholder-color: #999;
  padding: 0;
}

.custom-filters-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.filter-group {
  margin-bottom: 16px;
}
.filter-group:last-child {
  margin-bottom: 0;
}
.filter-group ion-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.filter-group ion-segment {
  width: 100%;
}
.filter-group ion-select {
  width: 100%;
  --background: #f5f7fa;
  --border-radius: 8px;
  --padding-start: 12px;
  --padding-end: 12px;
}

.orders-table-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
}
.orders-table thead {
  background: #f5f5f5;
}
.orders-table thead th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
  white-space: nowrap;
}
.orders-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.orders-table tbody tr:hover {
  background-color: #f9f9f9;
}
.orders-table tbody tr td {
  padding: 12px;
  color: #666;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.orders-cards-container {
  display: grid;
  gap: 12px;
}

.order-card {
  margin: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}
.order-card ion-card-header {
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}
.order-card ion-card-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
}
.order-card ion-card-subtitle {
  margin-top: 6px;
}
.order-card ion-card-content {
  padding: 12px;
}
.order-card .order-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 13px;
}
.order-card .order-detail-row:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
.order-card .order-detail-row .label {
  font-weight: 600;
  color: #666;
  font-size: 12px;
}
.order-card .order-detail-row .value {
  color: #333;
  font-weight: 500;
}
.order-card .order-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.order-card .order-details-grid .order-detail-row {
  border-bottom: none;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px;
}
.order-card .order-details-grid .order-detail-row .label {
  font-size: 11px;
  margin-bottom: 2px;
}
.order-card .order-details-grid .order-detail-row .value {
  font-size: 13px;
  font-weight: 600;
}

.summary-table-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.summary-table {
  width: 100%;
  border-collapse: collapse;
}
.summary-table thead {
  background: #f5f5f5;
}
.summary-table thead th {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #333;
  border: 1px solid #ddd;
  white-space: nowrap;
}
.summary-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}
.summary-table tbody tr:hover {
  background-color: #f9f9f9;
}
.summary-table tbody tr td {
  padding: 12px;
  text-align: center;
  color: #666;
  border: 1px solid #f0f0f0;
}
.summary-table tbody tr td:first-child {
  text-align: left;
  font-weight: 600;
  color: #333;
}

.charts-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.chart-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 400px;
}
.chart-container canvas {
  max-height: 100%;
}

.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 12px;
  }
  .summary-section {
    grid-template-columns: 1fr;
  }
  .summary-card .summary-stats-inline {
    flex-direction: column;
    gap: 16px;
  }
  .summary-card .stat-divider {
    width: 100%;
    height: 1px;
  }
  .summary-card .stat-inline {
    width: 100%;
    min-width: unset;
  }
  .status-boxes {
    grid-template-columns: repeat(2, 1fr);
  }
  .custom-filters-row {
    grid-template-columns: 1fr;
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }
  .charts-section {
    grid-template-columns: 1fr;
  }
  .chart-container {
    height: 300px;
  }
  .summary-table-container {
    padding: 8px;
  }
  .summary-table {
    font-size: 12px;
  }
  .summary-table th, .summary-table td {
    padding: 6px;
  }
}
.bonus-charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.bonus-table-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}
.bonus-table-container .table-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #667eea;
}

.customers-table {
  width: 100%;
  border-collapse: collapse;
}
.customers-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.customers-table thead th {
  padding: 12px;
  text-align: right;
  font-weight: 600;
  color: white;
  border: none;
  white-space: nowrap;
}
.customers-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.customers-table tbody tr:hover {
  background-color: #f9f9f9;
}
.customers-table tbody tr td {
  padding: 12px;
  color: #666;
}
.customers-table tbody tr td:first-child {
  font-weight: 600;
  color: #333;
}

@media (max-width: 768px) {
  .bonus-charts-grid {
    grid-template-columns: 1fr;
  }
  .bonus-table-container {
    overflow-x: auto;
    padding: 12px;
  }
  .bonus-table-container .table-title {
    font-size: 18px;
  }
  .customers-table {
    font-size: 14px;
  }
  .customers-table th, .customers-table td {
    padding: 8px;
  }
}
@media (max-width: 480px) {
  .status-boxes {
    grid-template-columns: 1fr;
  }
  .filter-group ion-segment {
    font-size: 12px;
  }
}
/* ===== LOADING SCREEN STYLES ===== */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%);
  background-size: 400% 400%;
  animation: gradientShift 6s ease infinite;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.loading-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* Animated background circles */
.circles-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  animation: floatCircle 8s ease-in-out infinite;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
  animation-duration: 10s;
}

.circle-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  left: 70%;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 20%;
  left: 80%;
  animation-delay: 4s;
  animation-duration: 8s;
}

.circle-4 {
  width: 250px;
  height: 250px;
  top: 70%;
  left: 15%;
  animation-delay: 1s;
  animation-duration: 11s;
}

@keyframes floatCircle {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translate(50px, -50px) scale(1.2);
    opacity: 0.5;
  }
}
/* Main loader */
.main-loader {
  position: relative;
  width: 200px;
  height: 200px;
  margin-bottom: 40px;
}

.loader-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 4px solid transparent;
}

.loader-ring-1 {
  width: 180px;
  height: 180px;
  border-top-color: rgba(255, 255, 255, 0.8);
  border-right-color: rgba(255, 255, 255, 0.8);
  animation: spin 2s linear infinite;
}

.loader-ring-2 {
  width: 140px;
  height: 140px;
  border-bottom-color: rgba(255, 255, 255, 0.6);
  border-left-color: rgba(255, 255, 255, 0.6);
  animation: spin 3s linear infinite reverse;
}

.loader-ring-3 {
  width: 100px;
  height: 100px;
  border-top-color: rgba(255, 255, 255, 0.4);
  border-right-color: rgba(255, 255, 255, 0.4);
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.loader-core {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  animation: pulse1 2s ease-in-out infinite;
}

@keyframes pulse1 {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);
  }
}
.loader-icon {
  font-size: 40px;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
/* Loading text */
.loading-text-container {
  text-align: center;
  margin-bottom: 30px;
}

.loading-title {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin: 0 0 20px 0;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  animation: titleGlow 2s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% {
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
    transform: scale(1);
  }
  50% {
    text-shadow: 0 0 40px rgba(255, 255, 255, 0.8);
    transform: scale(1.02);
  }
}
.loading-subtitle {
  font-size: 24px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-letter {
  display: inline-block;
  animation: wave 1.5s ease-in-out infinite;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.loading-letter:nth-child(1) {
  animation-delay: 0s;
}

.loading-letter:nth-child(2) {
  animation-delay: 0.1s;
}

.loading-letter:nth-child(3) {
  animation-delay: 0.2s;
}

.loading-letter:nth-child(4) {
  animation-delay: 0.3s;
}

.loading-letter:nth-child(5) {
  animation-delay: 0.4s;
}

.loading-letter:nth-child(6) {
  animation-delay: 0.5s;
}

.loading-letter:nth-child(7) {
  animation-delay: 0.6s;
}

@keyframes wave {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-10px) scale(1.1);
    opacity: 0.8;
  }
}
.loading-dots {
  display: inline-flex;
  margin-left: 5px;
}

.dot {
  display: inline-block;
  margin: 0 2px;
  animation: dotBounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    transform: translateY(-15px);
    opacity: 0.5;
  }
}
/* Progress bar */
.progress-bar-container {
  width: 300px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.8) 0%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.8) 100%);
  background-size: 200% 100%;
  border-radius: 3px;
  animation: progressMove 7s ease-out forwards, progressShine 1s linear infinite;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
}

@keyframes progressMove {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
@keyframes progressShine {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 0%;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .loading-title {
    font-size: 36px;
  }
  .loading-subtitle {
    font-size: 20px;
  }
  .main-loader {
    width: 150px;
    height: 150px;
  }
  .loader-ring-1 {
    width: 140px;
    height: 140px;
  }
  .loader-ring-2 {
    width: 100px;
    height: 100px;
  }
  .loader-ring-3 {
    width: 70px;
    height: 70px;
  }
  .loader-core {
    width: 60px;
    height: 60px;
  }
  .loader-icon {
    font-size: 30px;
  }
  .circle-1, .circle-2, .circle-3, .circle-4 {
    width: 150px;
    height: 150px;
  }
  .progress-bar-container {
    width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/main/main-agents/main-agents.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,6DAAA;AACF;;AAGA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,gDAAA;EACA,YAAA;EACA,yBAAA;AAAF;AAEE;EACE,2BAAA;EACA,iDAAA;AAAJ;AAGE;EACE,6DAAA;AADJ;AAIE;EACE,6DAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAHJ;AAKI;EACE,eAAA;EACA,YAAA;AAHN;AAMI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yCAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;AAPJ;AASI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,qBAAA;AAPN;AAUI;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;AARN;AAUM;EACE,cAAA;EACA,wCAAA;AARR;AAWM;EACE,cAAA;EACA,wCAAA;AATR;AAcE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AAZJ;;AAgBA;EACE;IACE,mBAAA;EAbF;EAeA;IACE,sBAAA;EAbF;AACF;AAiBA;EACE,mBAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE;IACE,UAAA;EAfF;EAiBA;IACE,UAAA;EAfF;AACF;AAmBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6EAAA;EACA,UAAA;EACA,6BAAA;AAjBJ;AAoBE;EACE,2BAAA;EACA,0CAAA;AAlBJ;AAoBI;EACE,UAAA;AAlBN;AAsBE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AApBJ;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AArBJ;;AA0BA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAvBF;;AA0BA;EACE,mBAAA;AAvBF;AAyBE;EACE,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAvBJ;;AA2BA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,mBAAA;AAxBF;AA0BE;EACE,gBAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAzBJ;AA4BE;EACE,WAAA;AA1BJ;AA6BE;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AA3BJ;;AAgCA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,yBAAA;AA7BF;AA+BE;EACE,mBAAA;AA7BJ;AA+BI;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;AA7BN;AAkCI;EACE,gCAAA;EACA,iCAAA;AAhCN;AAkCM;EACE,yBAAA;AAhCR;AAmCM;EACE,aAAA;EACA,WAAA;AAjCR;;AAuCA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AApCF;;AAwCA;EACE,aAAA;EACA,SAAA;AArCF;;AAwCA;EACE,SAAA;EACA,wCAAA;EACA,mBAAA;AArCF;AAuCE;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,4BAAA;AArCJ;AAwCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AAtCJ;AAyCE;EACE,eAAA;AAvCJ;AA0CE;EACE,aAAA;AAxCJ;AA2CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAzCJ;AA2CI;EACE,gCAAA;AAzCN;AA4CI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA1CN;AA6CI;EACE,WAAA;EACA,gBAAA;AA3CN;AAgDE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;AA9CJ;AAgDI;EACE,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AA9CN;AAgDM;EACE,eAAA;EACA,kBAAA;AA9CR;AAiDM;EACE,eAAA;EACA,gBAAA;AA/CR;;AAsDA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,yBAAA;AAnDF;AAqDE;EACE,mBAAA;AAnDJ;AAqDI;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AAnDN;AAwDI;EACE,gCAAA;AAtDN;AAwDM;EACE,yBAAA;AAtDR;AAyDM;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAvDR;AAyDQ;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AAvDV;;AA+DA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA5DF;;AA+DA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;AA5DF;AA8DE;EACE,gBAAA;AA5DJ;;AAiEA;EACE,cAAA;AA9DF;;AAiEA;EACE,aAAA;AA9DF;;AAiEA;EACE;IACE,aAAA;EA9DF;EAiEA;IACE,0BAAA;EA/DF;EAmEE;IACE,sBAAA;IACA,SAAA;EAjEJ;EAoEE;IACE,WAAA;IACA,WAAA;EAlEJ;EAqEE;IACE,WAAA;IACA,gBAAA;EAnEJ;EAuEA;IACE,qCAAA;EArEF;EAwEA;IACE,0BAAA;EAtEF;EAyEA;IACE,aAAA;EAvEF;EA0EA;IACE,cAAA;EAxEF;EA2EA;IACE,0BAAA;EAzEF;EA4EA;IACE,aAAA;EA1EF;EA6EA;IACE,YAAA;EA3EF;EA8EA;IACE,eAAA;EA5EF;EA8EE;IACE,YAAA;EA5EJ;AACF;AAiFA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA/EF;;AAkFA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;AA/EF;AAiFE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA/EJ;;AAmFA;EACE,WAAA;EACA,yBAAA;AAhFF;AAkFE;EACE,6DAAA;AAhFJ;AAkFI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAhFN;AAqFI;EACE,gCAAA;EACA,iCAAA;AAnFN;AAqFM;EACE,yBAAA;AAnFR;AAsFM;EACE,aAAA;EACA,WAAA;AApFR;AAsFQ;EACE,gBAAA;EACA,WAAA;AApFV;;AA2FA;EACE;IACE,0BAAA;EAxFF;EA2FA;IACE,gBAAA;IACA,aAAA;EAzFF;EA2FE;IACE,eAAA;EAzFJ;EA6FA;IACE,eAAA;EA3FF;EA6FE;IACE,YAAA;EA3FJ;AACF;AA+FA;EACE;IACE,0BAAA;EA7FF;EAiGE;IACE,eAAA;EA/FJ;AACF;AAuGA,sCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,oGAAA;EACA,0BAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AArGF;;AAwGA;EACE;IAAK,2BAAA;EApGL;EAqGA;IAAM,6BAAA;EAlGN;EAmGA;IAAO,2BAAA;EAhGP;AACF;AAkGA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAhGF;;AAmGA,gCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAhGF;;AAmGA;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,8CAAA;AAhGF;;AAmGA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAhGF;;AAmGA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAhGF;;AAmGA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AAhGF;;AAmGA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAhGF;;AAmGA;EACE;IACE,mCAAA;IACA,YAAA;EAhGF;EAkGA;IACE,4CAAA;IACA,YAAA;EAhGF;AACF;AAmGA,gBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,6BAAA;AAjGF;;AAoGA;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,4CAAA;EACA,kCAAA;AAjGF;;AAoGA;EACE,YAAA;EACA,aAAA;EACA,6CAAA;EACA,2CAAA;EACA,0CAAA;AAjGF;;AAoGA;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,4CAAA;EACA,oCAAA;AAjGF;;AAoGA;EACE;IAAO,6CAAA;EAhGP;EAiGA;IAAK,+CAAA;EA9FL;AACF;AAgGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,yCAAA;AA9FF;;AAiGA;EACE;IACE,yCAAA;IACA,6CAAA;EA9FF;EAgGA;IACE,2CAAA;IACA,6CAAA;EA9FF;AACF;AAiGA;EACE,eAAA;EACA,yCAAA;AA/FF;;AAkGA;EACE;IAAW,wBAAA;EA9FX;EA+FA;IAAM,4BAAA;EA5FN;AACF;AA8FA,iBAAA;AACA;EACE,kBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,4CAAA;AA5FF;;AA+FA;EACE;IACE,8CAAA;IACA,mBAAA;EA5FF;EA8FA;IACE,8CAAA;IACA,sBAAA;EA5FF;AACF;AA+FA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7FF;;AAgGA;EACE,qBAAA;EACA,yCAAA;EACA,8CAAA;AA7FF;;AAgGA;EAA+B,mBAAA;AA5F/B;;AA6FA;EAA+B,qBAAA;AAzF/B;;AA0FA;EAA+B,qBAAA;AAtF/B;;AAuFA;EAA+B,qBAAA;AAnF/B;;AAoFA;EAA+B,qBAAA;AAhF/B;;AAiFA;EAA+B,qBAAA;AA7E/B;;AA8EA;EAA+B,qBAAA;AA1E/B;;AA4EA;EACE;IACE,iCAAA;IACA,UAAA;EAzEF;EA2EA;IACE,uCAAA;IACA,YAAA;EAzEF;AACF;AA4EA;EACE,oBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,qBAAA;EACA,aAAA;EACA,8CAAA;AA1EF;;AA6EA;EAAoB,mBAAA;AAzEpB;;AA0EA;EAAoB,qBAAA;AAtEpB;;AAuEA;EAAoB,qBAAA;AAnEpB;;AAqEA;EACE;IACE,wBAAA;IACA,UAAA;EAlEF;EAoEA;IACE,4BAAA;IACA,YAAA;EAlEF;AACF;AAqEA,iBAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;UAAA,0BAAA;AAnEF;;AAsEA;EACE,YAAA;EACA,sHAAA;EAIA,0BAAA;EACA,kBAAA;EACA,8EAAA;EACA,6CAAA;AAtEF;;AAyEA;EACE;IAAO,SAAA;EArEP;EAsEA;IAAK,WAAA;EAnEL;AACF;AAqEA;EACE;IAAK,0BAAA;EAlEL;EAmEA;IAAO,4BAAA;EAhEP;AACF;AAkEA,2BAAA;AACA;EACE;IACE,eAAA;EAhEF;EAmEA;IACE,eAAA;EAjEF;EAoEA;IACE,YAAA;IACA,aAAA;EAlEF;EAqEA;IAAiB,YAAA;IAAc,aAAA;EAjE/B;EAkEA;IAAiB,YAAA;IAAc,aAAA;EA9D/B;EA+DA;IAAiB,WAAA;IAAa,YAAA;EA3D9B;EA6DA;IACE,WAAA;IACA,YAAA;EA3DF;EA8DA;IACE,eAAA;EA5DF;EA+DA;IACE,YAAA;IACA,aAAA;EA7DF;EAgEA;IACE,YAAA;EA9DF;AACF","sourcesContent":[".dashboard-container {\n  padding: 16px;\n  max-width: 1400px;\n  margin: 0 auto;\n  direction: rtl;\n  text-align: right;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n// Top Summary Section\n.summary-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.summary-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.25);\n  color: white;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.35);\n  }\n\n  &.today-card {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  }\n\n  &.month-card {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  }\n\n  .card-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n    ion-icon {\n      font-size: 32px;\n      color: white;\n    }\n\n    h3 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 700;\n      color: white;\n      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  .summary-stats-inline {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  .stat-inline {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    min-width: 120px;\n\n    .stat-label {\n      font-size: 13px;\n      font-weight: 500;\n      color: rgba(255, 255, 255, 0.9);\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .stat-value {\n      font-weight: 700;\n      font-size: 28px;\n      color: white;\n      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n      &.highlight {\n        color: #FFD700;\n        animation: pulse 2s ease-in-out infinite;\n      }\n\n      &.highlight-success {\n        color: #90EE90;\n        animation: pulse 2s ease-in-out infinite;\n      }\n    }\n  }\n\n  .stat-divider {\n    width: 1px;\n    height: 50px;\n    background: rgba(255, 255, 255, 0.2);\n    align-self: center;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n// Tabs\n.tabs-container {\n  margin-bottom: 24px;\n}\n\n.tab-content {\n  animation: fadeIn 0.3s;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n// Status Boxes\n.status-boxes {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.status-box {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  border-left: 5px solid;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, transparent 0%, rgba(0, 0, 0, 0.02) 100%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n\n    &::before {\n      opacity: 1;\n    }\n  }\n\n  .status-name {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .status-count {\n    font-size: 36px;\n    font-weight: 800;\n    color: #333;\n    line-height: 1;\n  }\n}\n\n// Filters Section\n.filters-section {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.search-group {\n  margin-bottom: 20px;\n\n  ion-searchbar {\n    --background: #f5f7fa;\n    --border-radius: 12px;\n    --box-shadow: none;\n    --placeholder-color: #999;\n    padding: 0;\n  }\n}\n\n.custom-filters-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.filter-group {\n  margin-bottom: 16px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  ion-label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n  }\n\n  ion-segment {\n    width: 100%;\n  }\n\n  ion-select {\n    width: 100%;\n    --background: #f5f7fa;\n    --border-radius: 8px;\n    --padding-start: 12px;\n    --padding-end: 12px;\n  }\n}\n\n// Orders Table (Desktop)\n.orders-table-container {\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  thead {\n    background: #f5f5f5;\n\n    th {\n      padding: 12px;\n      text-align: left;\n      font-weight: 600;\n      color: #333;\n      border-bottom: 2px solid #ddd;\n      white-space: nowrap;\n    }\n  }\n\n  tbody {\n    tr {\n      border-bottom: 1px solid #f0f0f0;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #f9f9f9;\n      }\n\n      td {\n        padding: 12px;\n        color: #666;\n      }\n    }\n  }\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n// Orders Cards (Mobile)\n.orders-cards-container {\n  display: grid;\n  gap: 12px;\n}\n\n.order-card {\n  margin: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n\n  ion-card-header {\n    padding: 12px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-radius: 12px 12px 0 0;\n  }\n\n  ion-card-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: white;\n  }\n\n  ion-card-subtitle {\n    margin-top: 6px;\n  }\n\n  ion-card-content {\n    padding: 12px;\n  }\n\n  .order-detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0;\n    font-size: 13px;\n\n    &:not(:last-child) {\n      border-bottom: 1px solid #f0f0f0;\n    }\n\n    .label {\n      font-weight: 600;\n      color: #666;\n      font-size: 12px;\n    }\n\n    .value {\n      color: #333;\n      font-weight: 500;\n    }\n  }\n\n  // Group fields in rows on mobile\n  .order-details-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px 12px;\n\n    .order-detail-row {\n      border-bottom: none;\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 4px;\n\n      .label {\n        font-size: 11px;\n        margin-bottom: 2px;\n      }\n\n      .value {\n        font-size: 13px;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n// Summary Table\n.summary-table-container {\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.summary-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  thead {\n    background: #f5f5f5;\n\n    th {\n      padding: 12px;\n      text-align: center;\n      font-weight: 600;\n      color: #333;\n      border: 1px solid #ddd;\n      white-space: nowrap;\n    }\n  }\n\n  tbody {\n    tr {\n      border-bottom: 1px solid #f0f0f0;\n\n      &:hover {\n        background-color: #f9f9f9;\n      }\n\n      td {\n        padding: 12px;\n        text-align: center;\n        color: #666;\n        border: 1px solid #f0f0f0;\n\n        &:first-child {\n          text-align: left;\n          font-weight: 600;\n          color: #333;\n        }\n      }\n    }\n  }\n}\n\n// Charts Section\n.charts-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-top: 24px;\n}\n\n.chart-container {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: 400px;\n\n  canvas {\n    max-height: 100%;\n  }\n}\n\n// Responsive styles\n.desktop-only {\n  display: block;\n}\n\n.mobile-only {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 12px;\n  }\n\n  .summary-section {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-card {\n    .summary-stats-inline {\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    .stat-divider {\n      width: 100%;\n      height: 1px;\n    }\n\n    .stat-inline {\n      width: 100%;\n      min-width: unset;\n    }\n  }\n\n  .status-boxes {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .custom-filters-row {\n    grid-template-columns: 1fr;\n  }\n\n  .desktop-only {\n    display: none;\n  }\n\n  .mobile-only {\n    display: block;\n  }\n\n  .charts-section {\n    grid-template-columns: 1fr;\n  }\n\n  .chart-container {\n    height: 300px;\n  }\n\n  .summary-table-container {\n    padding: 8px;\n  }\n\n  .summary-table {\n    font-size: 12px;\n\n    th, td {\n      padding: 6px;\n    }\n  }\n}\n\n// Bonus Dashboard Styles\n.bonus-charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.bonus-table-container {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  margin-bottom: 24px;\n\n  .table-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 2px solid #667eea;\n  }\n}\n\n.customers-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  thead {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n\n    th {\n      padding: 12px;\n      text-align: right;\n      font-weight: 600;\n      color: white;\n      border: none;\n      white-space: nowrap;\n    }\n  }\n\n  tbody {\n    tr {\n      border-bottom: 1px solid #f0f0f0;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #f9f9f9;\n      }\n\n      td {\n        padding: 12px;\n        color: #666;\n\n        &:first-child {\n          font-weight: 600;\n          color: #333;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .bonus-charts-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .bonus-table-container {\n    overflow-x: auto;\n    padding: 12px;\n\n    .table-title {\n      font-size: 18px;\n    }\n  }\n\n  .customers-table {\n    font-size: 14px;\n\n    th, td {\n      padding: 8px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .status-boxes {\n    grid-template-columns: 1fr;\n  }\n\n  .filter-group {\n    ion-segment {\n      font-size: 12px;\n    }\n  }\n}\n\n\n\n\n\n/* ===== LOADING SCREEN STYLES ===== */\n.loading-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%);\n  background-size: 400% 400%;\n  animation: gradientShift 6s ease infinite;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n@keyframes gradientShift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.loading-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n/* Animated background circles */\n.circles-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.circle {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n  animation: floatCircle 8s ease-in-out infinite;\n}\n\n.circle-1 {\n  width: 300px;\n  height: 300px;\n  top: 10%;\n  left: 10%;\n  animation-delay: 0s;\n  animation-duration: 10s;\n}\n\n.circle-2 {\n  width: 200px;\n  height: 200px;\n  top: 60%;\n  left: 70%;\n  animation-delay: 2s;\n  animation-duration: 12s;\n}\n\n.circle-3 {\n  width: 150px;\n  height: 150px;\n  top: 20%;\n  left: 80%;\n  animation-delay: 4s;\n  animation-duration: 8s;\n}\n\n.circle-4 {\n  width: 250px;\n  height: 250px;\n  top: 70%;\n  left: 15%;\n  animation-delay: 1s;\n  animation-duration: 11s;\n}\n\n@keyframes floatCircle {\n  0%, 100% {\n    transform: translate(0, 0) scale(1);\n    opacity: 0.3;\n  }\n  50% {\n    transform: translate(50px, -50px) scale(1.2);\n    opacity: 0.5;\n  }\n}\n\n/* Main loader */\n.main-loader {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin-bottom: 40px;\n}\n\n.loader-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 4px solid transparent;\n}\n\n.loader-ring-1 {\n  width: 180px;\n  height: 180px;\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-right-color: rgba(255, 255, 255, 0.8);\n  animation: spin 2s linear infinite;\n}\n\n.loader-ring-2 {\n  width: 140px;\n  height: 140px;\n  border-bottom-color: rgba(255, 255, 255, 0.6);\n  border-left-color: rgba(255, 255, 255, 0.6);\n  animation: spin 3s linear infinite reverse;\n}\n\n.loader-ring-3 {\n  width: 100px;\n  height: 100px;\n  border-top-color: rgba(255, 255, 255, 0.4);\n  border-right-color: rgba(255, 255, 255, 0.4);\n  animation: spin 1.5s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: translate(-50%, -50%) rotate(0deg); }\n  to { transform: translate(-50%, -50%) rotate(360deg); }\n}\n\n.loader-core {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n  animation: pulse1 2s ease-in-out infinite;\n}\n\n@keyframes pulse1 {\n  0%, 100% {\n    transform: translate(-50%, -50%) scale(1);\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    transform: translate(-50%, -50%) scale(1.1);\n    box-shadow: 0 0 50px rgba(255, 255, 255, 0.5);\n  }\n}\n\n.loader-icon {\n  font-size: 40px;\n  animation: bounce 1s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n/* Loading text */\n.loading-text-container {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.loading-title {\n  font-size: 48px;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 20px 0;\n  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n  animation: titleGlow 2s ease-in-out infinite;\n}\n\n@keyframes titleGlow {\n  0%, 100% {\n    text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n    transform: scale(1);\n  }\n  50% {\n    text-shadow: 0 0 40px rgba(255, 255, 255, 0.8);\n    transform: scale(1.02);\n  }\n}\n\n.loading-subtitle {\n  font-size: 24px;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-letter {\n  display: inline-block;\n  animation: wave 1.5s ease-in-out infinite;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n}\n\n.loading-letter:nth-child(1) { animation-delay: 0s; }\n.loading-letter:nth-child(2) { animation-delay: 0.1s; }\n.loading-letter:nth-child(3) { animation-delay: 0.2s; }\n.loading-letter:nth-child(4) { animation-delay: 0.3s; }\n.loading-letter:nth-child(5) { animation-delay: 0.4s; }\n.loading-letter:nth-child(6) { animation-delay: 0.5s; }\n.loading-letter:nth-child(7) { animation-delay: 0.6s; }\n\n@keyframes wave {\n  0%, 100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: translateY(-10px) scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n.loading-dots {\n  display: inline-flex;\n  margin-left: 5px;\n}\n\n.dot {\n  display: inline-block;\n  margin: 0 2px;\n  animation: dotBounce 1.4s ease-in-out infinite;\n}\n\n.dot:nth-child(1) { animation-delay: 0s; }\n.dot:nth-child(2) { animation-delay: 0.2s; }\n.dot:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes dotBounce {\n  0%, 80%, 100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  40% {\n    transform: translateY(-15px);\n    opacity: 0.5;\n  }\n}\n\n/* Progress bar */\n.progress-bar-container {\n  width: 300px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  backdrop-filter: blur(5px);\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg,\n    rgba(255, 255, 255, 0.8) 0%,\n    rgba(255, 255, 255, 1) 50%,\n    rgba(255, 255, 255, 0.8) 100%);\n  background-size: 200% 100%;\n  border-radius: 3px;\n  animation: progressMove 7s ease-out forwards, progressShine 1s linear infinite;\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);\n}\n\n@keyframes progressMove {\n  from { width: 0%; }\n  to { width: 100%; }\n}\n\n@keyframes progressShine {\n  0% { background-position: 0% 0%; }\n  100% { background-position: 200% 0%; }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .loading-title {\n    font-size: 36px;\n  }\n\n  .loading-subtitle {\n    font-size: 20px;\n  }\n\n  .main-loader {\n    width: 150px;\n    height: 150px;\n  }\n\n  .loader-ring-1 { width: 140px; height: 140px; }\n  .loader-ring-2 { width: 100px; height: 100px; }\n  .loader-ring-3 { width: 70px; height: 70px; }\n\n  .loader-core {\n    width: 60px;\n    height: 60px;\n  }\n\n  .loader-icon {\n    font-size: 30px;\n  }\n\n  .circle-1, .circle-2, .circle-3, .circle-4 {\n    width: 150px;\n    height: 150px;\n  }\n\n  .progress-bar-container {\n    width: 250px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
